import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { TabViewModule } from 'primeng/tabview';
import { EnviarEmailComponent } from './enviar-email/enviar-email.component';
import { UploadComponent } from './upload/upload.component';
import { TagModule } from 'primeng/tag';
import { ShowForRolesDirective } from '@directives/show-for-roles.directive';

@Component({
  selector: 'app-semanas-cotizadas',
  imports: [CommonModule, BackboneComponent, BreadcrumbComponent, TabViewModule, ShowForRolesDirective, EnviarEmailComponent, UploadComponent, TagModule],
  templateUrl: './semanas-cotizadas.component.html',
  styleUrl: './semanas-cotizadas.component.scss',
})
export class SemanasCotizadasPage {}
